"use strict";

var _slicedToArray = require("/agent/_work/4/s/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_redux_1 = require("react-redux");

var loading_reducer_1 = require("./loading.reducer");

exports.useLoadingStatus = function (key) {
  var defaultStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : loading_reducer_1.LOADING;
  var status = react_redux_1.useSelector(function (state) {
    return state.loadingState[key];
  }) || defaultStatus;
  var loading = status === loading_reducer_1.LOADING;
  var error = isLoadingError(status) ? status : undefined;
  return [loading, error];
};

exports.useGlobalLoadingStatus = function () {
  var statuses = react_redux_1.useSelector(function (state) {
    return state.loadingState;
  });
  return !!Object.entries(statuses).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        status = _ref2[1];

    return status === loading_reducer_1.LOADING;
  });
};

function isLoadingError(status) {
  return typeof status === "object";
}